import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "favourite" }, [
      _createElementVNode("g", { id: "elements" }, [
        _createElementVNode("path", {
          id: "Vector",
          d: "M22.7064 4.65988C19.5778 2.7408 16.8472 3.51416 15.2068 4.74605C14.5342 5.25115 14.1979 5.5037 14 5.5037C13.8022 5.5037 13.4659 5.25115 12.7933 4.74605L12.7933 4.74605C11.1529 3.51416 8.42231 2.7408 5.29372 4.65988C1.18779 7.17845 0.258715 15.4874 9.72949 22.4973C11.5334 23.8324 12.4353 24.5 14 24.5C15.5648 24.5 16.4667 23.8324 18.2706 22.4973C27.7414 15.4874 26.8123 7.17845 22.7064 4.65988Z",
          stroke: "white",
          "stroke-width": "2",
          "stroke-linecap": "round"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }